import { getHeaders } from '@utility/helperFunction';

export const GET_SENSORS_GROUP_LIST_REQUESTED = 'sensors/GET_SENSORS_GROUP_LIST_REQUESTED';
export const GET_SENSORS_GROUP_LIST_SUCCESS = 'sensors/GET_SENSORS_GROUP_LIST_SUCCESS';
export const GET_SENSORS_GROUP_LIST_FAILURE = 'sensors/GET_SENSORS_GROUP_LIST_FAILURE';

export const DELETE_SENSOR_REQUESTED = 'sensors/DELETE_SENSOR_REQUESTED';
export const DELETE_SENSOR_SUCCESS = 'sensors/DELETE_SENSOR_SUCCESS';
export const DELETE_SENSOR_FAILURE = 'sensors/DELETE_SENSOR_FAILURE';

export const ADD_SENSOR_REQUESTED = 'sensors/ADD_SENSOR_REQUESTED';
export const ADD_SENSOR_SUCCESS = 'sensors/ADD_SENSOR_SUCCESS';
export const ADD_SENSOR_FAILURE = 'sensors/ADD_SENSOR_FAILURE';

export const GET_NAMED_SENSOR_LIST_REQUESTED = 'sensors/GET_NAMED_SENSOR_LIST_REQUESTED';
export const GET_NAMED_SENSOR_LIST_SUCCESS = 'sensors/GET_NAMED_SENSOR_LIST_SUCCESS';
export const GET_NAMED_SENSOR_LIST_FAILURE = 'sensors/GET_NAMED_SENSOR_LIST_FAILURE';

export const UPDATE_SENSOR_GROUP_REQUESTED = 'sensors/UPDATE_SENSOR_GROUP_REQUESTED';
export const UPDATE_SENSOR_GROUP_SUCCESS = 'sensors/UPDATE_SENSOR_GROUP_SUCCESS';
export const UPDATE_SENSOR_GROUP_FAILURE = 'sensors/UPDATE_SENSOR_GROUP_FAILURE';


const initialState = {
    loading: false,
    loaded: false,
    error: false,
};

const setLoadingState = state => ({
    ...state,
    loading: true,
    loaded: false,
    error: false,
});

const setLoadedState = state => ({
    ...state,
    loading: false,
    loaded: true,
    error: false,
});

const setErrorState = state => ({
    ...state,
    loading: false,
    loaded: false,
    error: true,
});

export default (state = initialState, action) => {
    switch (action.type) {

        case GET_SENSORS_GROUP_LIST_REQUESTED:
        case DELETE_SENSOR_REQUESTED:
        case ADD_SENSOR_REQUESTED:
        case GET_NAMED_SENSOR_LIST_REQUESTED:
        case UPDATE_SENSOR_GROUP_REQUESTED:
            return setLoadingState(state);

        case GET_SENSORS_GROUP_LIST_SUCCESS:
        case DELETE_SENSOR_SUCCESS:
        case ADD_SENSOR_SUCCESS:
        case GET_NAMED_SENSOR_LIST_SUCCESS:
        case UPDATE_SENSOR_GROUP_SUCCESS:
            return setLoadedState(state);

        case GET_SENSORS_GROUP_LIST_FAILURE:
        case DELETE_SENSOR_FAILURE:
        case ADD_SENSOR_FAILURE:
        case GET_NAMED_SENSOR_LIST_FAILURE:
        case UPDATE_SENSOR_GROUP_FAILURE:
            return setErrorState(state);
        default:
            return state;
    }
};

export const getSensorsGroupList = (storeId) => {
    const headers = getHeaders();

    return {
        types: [
            GET_SENSORS_GROUP_LIST_REQUESTED,
            GET_SENSORS_GROUP_LIST_SUCCESS,
            GET_SENSORS_GROUP_LIST_FAILURE,
        ],
        promise: client => client.get(`tableSensorsList/${storeId}`, { headers })
    }
}

export const deRegisterSensor = (sensorId) => {
    const headers = getHeaders();

    return {
        types: [
            DELETE_SENSOR_REQUESTED,
            DELETE_SENSOR_SUCCESS,
            DELETE_SENSOR_FAILURE,
        ],
        promise: client => client.post(`deRegisterSensor/${sensorId}`, { headers })
    }
}

export const registerSensor = (data) => {
    const headers = getHeaders();

    return {
        types: [
            ADD_SENSOR_REQUESTED,
            ADD_SENSOR_SUCCESS,
            ADD_SENSOR_FAILURE,
        ],
        promise: client => client.post('registerSensor', { data, headers })
    }
}

export const getNamedSensors = (storeId) => {
    const headers = getHeaders();

    return {
        types: [GET_NAMED_SENSOR_LIST_REQUESTED, GET_NAMED_SENSOR_LIST_SUCCESS, GET_NAMED_SENSOR_LIST_FAILURE],
        promise: client => client.get(`namedSensorsList/${storeId}`, { headers })
    }
}

export const assignSensorGroup = (sensorId, sensorGroupId) => {
    const headers = getHeaders();
    return {
        types: [UPDATE_SENSOR_GROUP_REQUESTED, UPDATE_SENSOR_GROUP_SUCCESS, UPDATE_SENSOR_GROUP_FAILURE],
        promise: client => client.post(`assignSensorGroup/${sensorId}/sensorGroupId/${sensorGroupId}`, { headers })
    }
}
